/**
 * Auth Layout Component
 * Shared layout for authentication pages
 */

import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '../layout/LanguageSwitcher';
import { LoopyMark } from '../loopy';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title, subtitle }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 relative">
      {/* Language Switcher - Top Right */}
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>

      <div className="max-w-md w-full space-y-8">
        {/* Logo and Brand */}
        <div className="text-center">
          <Link to="/" className="inline-flex items-center gap-3">
            <LoopyMark size={36} />
            <h1 className="text-4xl font-bold text-primary-500 tracking-tight hover:text-primary-600 transition-colors">
              Loopy AI
            </h1>
          </Link>
          <h2 className="mt-4 text-2xl font-semibold text-gray-900">{title}</h2>
          {subtitle && <p className="mt-2 text-sm text-gray-500">{subtitle}</p>}
        </div>

        {/* Card */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
